import { useEffect, useRef, useState } from "react";
import { Sparkles } from "lucide-react";
import { streamPost } from "@/lib/api";
import { t } from "@/lib/i18n";

export const AiSummary = ({ vid, lang }) => {
  const [text, setText] = useState("");
  const [state, setState] = useState("loading");
  const started = useRef("");

  useEffect(() => {
    if (started.current === lang) return;
    started.current = lang;
    setText("");
    setState("loading");
    streamPost(`/public/results/${vid}/summary?lang=${lang}`, null, (d) => setText((p) => p + d))
      .then(() => setState("done"))
      .catch(() => setState("error"));
  }, [vid, lang]);

  return (
    <section className="card-soft p-8 md:p-10 border-l-4 !border-l-[var(--teal)]" data-testid="ai-summary">
      <p className="eyebrow flex items-center gap-2"><Sparkles size={14} /> {t(lang, "aiSummary")}</p>
      {state === "error" ? (
        <p className="text-muted-ink mt-4" data-testid="ai-summary-error">{t(lang, "aiError")}</p>
      ) : (
        <div className="text-navy text-lg leading-relaxed mt-4 whitespace-pre-line" data-testid="ai-summary-text">
          {text || <span className="text-muted-ink animate-pulse">{t(lang, "aiWriting")}</span>}
        </div>
      )}
    </section>
  );
};
